import { onMessage } from "firebase/messaging";
import { enqueueSnackbar } from "notistack";
import { messaging } from "./firebase";
import { Link } from "react-router-dom";
import { paths } from "src/routes/paths";

export const setupFCMListener = ({ onSuccess }: { onSuccess: () => void }) =>
  onMessage(messaging, (payload) => {
    enqueueSnackbar({
      variant: "warning",
      autoHideDuration: 5000,
      message: (
        <Link to={paths.custom[payload.data?.platform as "youtube"](payload.data)}>
          {payload?.notification?.body}
        </Link>
      ),
    });

    onSuccess();
  });
